export default class ProductDetailArgsModel {
    public initialLoad = true;
    public eventProductId: number | null = null;
    public selectedColorId: number | null = null;
    public selectedSizeId: number | null = null;
    public excludedCartItemId: number | null = null;
}
